import fetch from 'unfetch';

import { queryParams } from './request';

export function autocompleteCompanyName(values) {
  const query = queryParams(values);

  return fetch(
    `https://autocomplete.clearbit.com/v1/companies/suggest?${query}`,
  ).then((response) => response.json());
}
